import {
  SITES_REQUEST, SITES_SUCCESS, SITES_UPDATE_REQUEST, SITES_CHANGES_SAVING, SITES_CHANGES_SAVED, POPUP_IN_PROGRESS,
  SITES_CANCEL_CHANGES
} from '../../constants/actionTypes';
import {getApiConfig} from '../../utilities/index';
import {getChangedSites} from './SitesReducer';

const getSitesMethods = getApiConfig('Siteadmin/GetSites');
const changeSiteMethods = getApiConfig('Siteadmin/UpdateSite');

export const ActionTypes = {
  DELETE_SITE_REQUEST: 'sites/delete-site-request',
  DELETE_SITE_RESPONSE: 'sites/delete-site-response'
}

export const getSites = (page = 0, searchKeyword, sortKeyword, order) => {
  return dispatch => {
    dispatch({type: SITES_REQUEST, searchKeyword});

    const data = {
      page,
      pageSize: 50
    };

    if (searchKeyword) {
      data.FilterBy = {
        name: searchKeyword
      }
    }

    if (sortKeyword && order) {
      data.SortBy = {};
      data.SortBy[sortKeyword] = order;
    }

    getSitesMethods.post(data)
      .then(data => dispatch({
        type: SITES_SUCCESS,
        payload: data
      }));
  }
};

export const updateSite = (value, propName, site) => {
  return dispatch => {
    dispatch({type: SITES_UPDATE_REQUEST, payload: {value, propName, site}});
  }
};

export const saveSites = () => {
  return (dispatch, getState) => {
    dispatch({
      type: POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: 'Saving...',
        message: 'Please wait while we are storing your changes.'
      }
    });


    dispatch({type: SITES_CHANGES_SAVING});

    const state = getState();

    changeSiteMethods.post(getChangedSites(state.sites))
      .then(data => {
        dispatch({
          type: POPUP_IN_PROGRESS,
          payload: {show: false}
        });

        dispatch({type: SITES_CHANGES_SAVED, payload: data});
      });
  }
}

export const cancelSitesChanges = () => {
  return {type: SITES_CANCEL_CHANGES}
}

export const deleteSite = site => {
  return dispatch => {
    dispatch({type: ActionTypes.DELETE_SITE_REQUEST, payload: site});

    getApiConfig('Siteadmin/UpdateSite')
      .post([{
        site_id: site.site_id,
        subDomain: ''
      }])
      .then(data => {
        dispatch({
          type: ActionTypes.DELETE_SITE_RESPONSE,
          payload: data
        });
      })
  }
}

